import React from 'react';
import {Card, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import { translate } from 'react-i18next';
import ProductPictureDialog from './ProductPictureDialog';
import {GridList, GridTile} from 'material-ui/GridList';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import Star from 'material-ui/svg-icons/toggle/star';
import IconButton from 'material-ui/IconButton';


class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      pictureUrls: []
    };
  }

  componentDidMount = () => {
    const {productKey, categoryKey} = this.props;
    if (productKey && categoryKey) {
      this.setState({productKey, categoryKey});
      this.getProduct(productKey, categoryKey);
    }
  }

  componentWillUnmount = () => {
    const {firebase, categoryKey, productKey} = this.props;
    firebase
      .database()
      .ref(`portfolio/${categoryKey}/products/${productKey}/pictures`)
      .off('child_added');

    firebase
      .database()
      .ref(`portfolio/${categoryKey}/products/${productKey}`)
      .off('value');
  }

  getProduct = (productKey, categoryKey) => {
    const {firebase} = this.props;
    firebase
      .database()
      .ref(`portfolio/${categoryKey}/products/${productKey}`)
      .on('value', (data) => {
        this.setState({...data.val()});
      });

    firebase
      .database()
      .ref(`portfolio/${categoryKey}/products/${productKey}/pictures`)
      .on('child_added', this.addPicture);
  }

  addPicture = (snapshot) => {
    const {firebase} = this.props;
    firebase.storage().ref(snapshot.val().location).getDownloadURL().then((url) => {
      const currentPictures = this.state.pictureUrls.slice();
      currentPictures.push({url, ref: snapshot.val().location});
      this.setState({pictureUrls: currentPictures});
    });
  }

  openUploadDialog = () => this.setState({dialogOpen: true});
  hadleDialogClose = () => this.setState({dialogOpen: false});

  handleSelectPicture = (picture) => {

    const newVisiblePictureRef = this.state.picture === picture.ref ? null : picture.ref;

    const {firebase, categoryKey, productKey} = this.props;
    firebase
      .database()
      .ref(`portfolio/${categoryKey}/products/${productKey}`)
      .update({picture: newVisiblePictureRef});

    this.setState({picture: newVisiblePictureRef});
  };

  render()  {
    const {t} = this.props;

    const styles = {
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start'
      },
      gridList: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto',
      },
      tile: {
        width: '170px',
        height: '170px',
      },
      picture: {
        width: '170px',
        height: '170px',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    };

    const gridList = this.state.pictureUrls
      .sort((picture, nextPicture) => {
        const pictureName = picture.url.split('%2F').pop().split('.')[0];
        const nextPictureName = nextPicture.url.split('%2F').pop().split('.')[0];
        return parseInt(nextPictureName, 10) - parseInt(pictureName, 10);
      })
      .map((picture) => {
        const selected = this.state.picture === picture.ref;
        return (
          <GridTile
            key={picture.url}
            style={styles.tile}
            title={selected ? 'Visible picture' : 'Hidden picture'}
            actionIcon={<IconButton onTouchTap={this.handleSelectPicture.bind(this, picture)}>{selected ? <Star color="white" />  : <StarBorder color="white" />}</IconButton>}>
            <div style={{backgroundImage: `url('${picture.url}')`, ...styles.picture }}  />
          </GridTile>
        );});

    return (
      <Card className='cardStyle' >
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={t('product.picture')} />
          </ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <FlatButton label={t('product.uploadPicture')}
              onTouchTap={this.openUploadDialog}
              primary={true} />
          </ToolbarGroup>
        </Toolbar>

        {
          this.state.pictureUrls.length > 0 ?
          <div style={styles.root}>
            <GridList
              cols={2.2}
              style={styles.gridList}>
           {gridList}
          </GridList>
          </div>
          :
          <CardText><p>{t('product.noPictures')}</p></CardText>
        }

        <ProductPictureDialog open={this.state.dialogOpen} handleClose={this.hadleDialogClose} productKey={this.props.productKey} categoryKey={this.props.categoryKey}/>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Product);



// WEBPACK FOOTER //
// ./src/Admin/ProductPicturesCard.js